import React from "react";
import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import ScoringSetup from "../ScoringSetup";
import Container from "../Container";
import Page from "../Page";

const ScoringSetupPage: React.FunctionComponent = () => {
  return (
    <Page>
      <Container>
        <div className="mb-6">
          <Heading level={1} variant="lg">Scoring Setup</Heading>
          <Text variant="sm" className="text-muted-foreground">
            Configure how agent performance is measured and scored
          </Text>
        </div>

        <ScoringSetup showHeader={false} />
      </Container>
    </Page>
  );
};

export default ScoringSetupPage;
